import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { api } from "@/lib/api";
import { brl } from "@/lib/fmt";
import { H, Stat } from "./ui";

const CANAL = { loja: "Loja", landing: "Landing", vitrine: "Vitrine", whatsapp: "WhatsApp", manual: "Manual", assinatura: "Assinatura" };

export default function Dashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setD(r.data)).catch(() => setD(false)); }, []);
  if (d === false) return <p>Sem acesso ao painel.</p>;
  if (!d) return <p>Carregando...</p>;
  return (
    <div data-testid="admin-dashboard">
      <H>Painel</H>
      {d.tem_exemplos && <p className="mb-4 rounded-2xl bg-amber-50 p-3 text-sm text-amber-900" data-testid="demo-data-warning">Há dados de exemplo no sistema. Apague antes do lançamento em Configurações.</p>}
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <Stat label="Faturamento (pagos)" value={brl(d.faturamento)} testid="stat-revenue" tone="bg-na-sage2" />
        <Stat label="Ticket médio" value={brl(d.ticket_medio)} testid="stat-ticket" />
        <Stat label="Para enviar" value={d.para_enviar} testid="stat-to-ship" />
        <Stat label="Aguardando pagamento" value={d.aguardando} testid="stat-awaiting" />
      </div>
      <div className="mt-6 grid gap-6 lg:grid-cols-3">
        <div className="card-na p-6 lg:col-span-2">
          <h2 className="font-serif text-xl">Vendas por dia (30 dias)</h2>
          <div className="mt-4 h-64"><ResponsiveContainer><BarChart data={d.por_dia}><XAxis dataKey="data" fontSize={10} /><YAxis fontSize={10} /><Tooltip formatter={(v) => brl(v)} /><Bar dataKey="valor" fill="#1E4D3A" radius={[6, 6, 0, 0]} /></BarChart></ResponsiveContainer></div>
        </div>
        <div className="card-na p-6" data-testid="attention-list">
          <h2 className="font-serif text-xl">O que precisa de atenção</h2>
          <ul className="mt-4 max-h-64 space-y-2 overflow-y-auto text-sm">
            {d.atencao.map((a, i) => <li key={i} className="flex gap-2"><AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-na-gold" /><Link to={a.tipo === "pedido" ? "/admin/pedidos" : "/admin/estoque"} className="hover:underline">{a.texto}</Link></li>)}
            {!d.atencao.length && <li className="text-na-ink2">Tudo em dia.</li>}
          </ul>
        </div>
        <div className="card-na p-6">
          <h2 className="font-serif text-xl">Mais vendidos</h2>
          <ul className="mt-4 space-y-2 text-sm">{d.mais_vendidos.map((p) => <li key={p.nome} className="flex justify-between"><span>{p.nome}</span><b>{p.unidades} un.</b></li>)}</ul>
        </div>
        <div className="card-na p-6 lg:col-span-2">
          <h2 className="font-serif text-xl">Vendas por canal</h2>
          <ul className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-4" data-testid="sales-by-channel">{d.por_canal.map((c) => <li key={c.canal} className="rounded-2xl bg-na-sage2 p-4"><p className="text-xs text-na-ink2">{CANAL[c.canal] || c.canal}</p><p className="font-bold">{brl(c.valor)}</p></li>)}</ul>
        </div>
      </div>
    </div>
  );
}
